export type ImageProps = {
  url: string
  alt?: string
  className?: string
  style?: React.CSSProperties
  template: ImageTemplate
}

export type ImageTemplate =
  | 'user-sm'
  | 'user-md'
  | 'user-lg'
  | 'listing-xs'
  | 'listing-sm'
  | 'listing-md'
  | 'listing-lg'
  | 'listing-xl'
  | 'logo-sm'
  | 'logo-md'
  | 'external'

export const imageTemplates: Record<ImageTemplate, string> = {
  'user-sm': 'mode=face&width=70&height=70',
  'user-md': 'mode=face&width=340&height=340',
  'user-lg': 'mode=face&width=384&height=514',
  'listing-xs': 'mode=crop&width=128&height=96',
  'listing-sm': 'mode=crop&width=512&height=384',
  'listing-md': 'mode=crop&width=1024&height=768',
  'listing-lg': 'mode=max&width=1280&height=720',
  'listing-xl': 'mode=max&width=1920&height=1280',
  'logo-sm': 'mode=max&width=114&height=64',
  'logo-md': 'mode=max&width=220&height=92',
  external: '',
}
